
    import '/home/ec2-user/Youlify-Design/components/avatar/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["avatar-demo-basic","avatar-demo-type","avatar-demo-dynamic","avatar-demo-badge","avatar-demo-group","avatar-demo-toggle-debug","avatar-demo-responsive","avatar-demo-fallback","avatar-demo-component-token"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/avatar/index.zh-CN.md?type=demo')
};